import { render, staticRenderFns } from "./editContactPatient.vue?vue&type=template&id=782870b6&scoped=true"
import script from "./editContactPatient.vue?vue&type=script&lang=js"
export * from "./editContactPatient.vue?vue&type=script&lang=js"
import style0 from "./editContactPatient.vue?vue&type=style&index=0&id=782870b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782870b6",
  null
  
)

export default component.exports